import ReactPixel from 'react-facebook-pixel';



class FbPixel {
  
  constructor(){
    ReactPixel.init(process.env.REACT_APP_FB_PIXEL);
  }

  recordEvent(eventName, data){
    return ReactPixel.track( eventName, data ) 
  }

  recordCustomEvent(eventName, data){
    return ReactPixel.trackCustom( eventName, data ) 
  }
}
const Pixel = new FbPixel()
export default Pixel